import React from 'react';
import styles from './CommonNoShippingModal.module.css';
import { PiHouseLineLight } from "react-icons/pi";

const CommonNoShippingModal = ({ isOpen, onClose, redirect, title, subTitle, btnText }) => {
    if (!isOpen) return null;

    return (
        <div className={styles.modalOverlay}>
            <div className={styles.modalContent}>
                <button className={styles.modalClose} onClick={() => onClose(false)} aria-label="Close modal">
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </button>
                
                <div className={styles.modalIcon}>
                <PiHouseLineLight size={64} />
                </div>
                
                <h2 className={styles.modalTitle}>{title}</h2>
                <p className={styles.modalMessage}>{subTitle}</p>
                
                <button className={styles.modalButton} onClick={redirect}>
                    {btnText}
                </button>
            </div>
        </div>
    );
};

export default CommonNoShippingModal;
